export const floatingLabels = {
  id: "floatingLabels",
  afterDatasetsDraw(chart) {
    if (chart.canvas.id == "my-chart-bar-percentage") {
      // console.log(chart);
      chart.ctx.save();

      const datasetArray = chart.data.datasets[0].data.map(
        (datapoint, index) => {
          if (datapoint > chart.data.datasets[1].data[index]) {
            return 0;
          } else {
            return 1;
          }
        }
      );

      const percentageArray = [
        "26,2%",
        "30,7%",
        "3,1%",
        "-1,8%",
        "309,5%",
        "15,9%",
        "132,6%",
      ];

      //  console.log(diffArray)

      datasetArray.forEach((value, index) => {
        chart.ctx.font = "bold 14px sans-serif";
        chart.ctx.fillStyle = "#666";
        chart.ctx.texAlign = "center";
        chart.ctx.fillText(
          percentageArray[index],
          chart.scales.x.getPixelForValue(index) - 15,
          chart.getDatasetMeta(datasetArray[index]).data[index].y - 10
        );
      });
    }
  },
};
